module.exports = __webpack_public_path__ + "img/logo-default.ec0c67e9.png";